define("shared/components/shared/upgrade/trial-info", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "later/utils/compare-strings"], function (_exports, _component, _templateFactory, _component2, _object, _service, _compareStrings) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _getDateFromToday, _getMonthlyDateFormat;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"later/utils/compare-strings",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.shouldSeeTrialInfo}}
    <Shared::CollapsableInfoCard @title={{t "plans.trial_info_card.title"}} @onCollapsedAction={{this.trackHidTimeline}}>
      {{!-- Timeline --}}
      <div class="tPF--timeline">
        {{!-- Day: Today --}}
        <div class="tPF--timeline__item">
          {{!-- Title --}}
          <div class="tPF--timeline__title">{{t "plans.trial_info_card.today"}}</div>
          {{!-- Meter --}}
          <div class="tPF--timeline__meter">
            <div class="tPF--timeline__meterGauge tPF--timeline__meterGauge--active"></div>
          </div>
          {{!-- Description --}}
          <div class="tPF--timeline__description u--text--bold">{{t "plans.trial_info_card.today_event"}}</div>
        </div>
        {{!-- Day: 12th Day --}}
        <div class="tPF--timeline__item">
          {{!-- Title --}}
          <div class="tPF--timeline__title">{{this.dayTwelveTitle}}</div>
          {{!-- Meter --}}
          <div class="tPF--timeline__meter">
            <div class="tPF--timeline__meterGauge"></div>
          </div>
          {{!-- Description --}}
          <div class="tPF--timeline__description">{{t "plans.trial_info_card.day12_event"}}</div>
        </div>
        {{!-- Day: 12th Day --}}
        <div class="tPF--timeline__item">
          {{!-- Title --}}
          <div class="tPF--timeline__title">{{this.dayFifteenTitle}}</div>
          {{!-- Meter --}}
          <div class="tPF--timeline__meter">
            <div class="tPF--timeline__meterGauge"></div>
          </div>
          {{!-- Description --}}
          <div class="tPF--timeline__description">{{t "plans.trial_info_card.day15_event" date=this.dayFifteenFullDate}}</div>
        </div>
      </div>
    </Shared::CollapsableInfoCard>
  {{/if}}
  */
  {
    "id": "IEmEm0hT",
    "block": "[[[41,[30,0,[\"shouldSeeTrialInfo\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@title\",\"@onCollapsedAction\"],[[28,[37,2],[\"plans.trial_info_card.title\"],null],[30,0,[\"trackHidTimeline\"]]]],[[\"default\"],[[[[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"tPF--timeline\"],[12],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"tPF--timeline__item\"],[12],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"tPF--timeline__title\"],[12],[1,[28,[35,2],[\"plans.trial_info_card.today\"],null]],[13],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"tPF--timeline__meter\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"tPF--timeline__meterGauge tPF--timeline__meterGauge--active\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"tPF--timeline__description u--text--bold\"],[12],[1,[28,[35,2],[\"plans.trial_info_card.today_event\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"tPF--timeline__item\"],[12],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"tPF--timeline__title\"],[12],[1,[30,0,[\"dayTwelveTitle\"]]],[13],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"tPF--timeline__meter\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"tPF--timeline__meterGauge\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"tPF--timeline__description\"],[12],[1,[28,[35,2],[\"plans.trial_info_card.day12_event\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"tPF--timeline__item\"],[12],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"tPF--timeline__title\"],[12],[1,[30,0,[\"dayFifteenTitle\"]]],[13],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"tPF--timeline__meter\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"tPF--timeline__meterGauge\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"tPF--timeline__description\"],[12],[1,[28,[35,2],[\"plans.trial_info_card.day15_event\"],[[\"date\"],[[30,0,[\"dayFifteenFullDate\"]]]]]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"shared/collapsable-info-card\",\"t\"]]",
    "moduleName": "shared/components/shared/upgrade/trial-info.hbs",
    "isStrictMode": false
  });

  let TrialInfo = (_class = (_getDateFromToday = /*#__PURE__*/new WeakSet(), _getMonthlyDateFormat = /*#__PURE__*/new WeakSet(), class TrialInfo extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _getMonthlyDateFormat);

      _classPrivateMethodInitSpec(this, _getDateFromToday);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "locale", _descriptor2, this);

      _initializerDefineProperty(this, "segment", _descriptor3, this);
    }

    get shouldSeeTrialInfo() {
      var _this$auth$currentAcc;

      return (0, _compareStrings.areStringsEqual)((_this$auth$currentAcc = this.auth.currentAccount) === null || _this$auth$currentAcc === void 0 ? void 0 : _this$auth$currentAcc.experiments['web_plan-snapshot_trial-timeline'], 'saw-timeline');
    }

    get today() {
      return new Date().getDate();
    }

    get dayTwelveTitle() {
      return _classPrivateMethodGet(this, _getMonthlyDateFormat, _getMonthlyDateFormat2).call(this).format(_classPrivateMethodGet(this, _getDateFromToday, _getDateFromToday2).call(this, 12));
    }

    get dayFifteenTitle() {
      return _classPrivateMethodGet(this, _getMonthlyDateFormat, _getMonthlyDateFormat2).call(this).format(_classPrivateMethodGet(this, _getDateFromToday, _getDateFromToday2).call(this, 15));
    }

    get dayFifteenFullDate() {
      return this.locale.formatDate(_classPrivateMethodGet(this, _getDateFromToday, _getDateFromToday2).call(this, 15), this.locale.DATE_LENGTH.MEDIUM);
    }

    trackHidTimeline() {
      this.segment.track('clicked-hide-timeline', {
        page: 'plan_snapshot'
      });
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "trackHidTimeline", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackHidTimeline"), _class.prototype)), _class);
  _exports.default = TrialInfo;

  function _getDateFromToday2(daysFromToday) {
    return new Date().setDate(this.today + daysFromToday);
  }

  function _getMonthlyDateFormat2() {
    // Note: returns short month + date format ie. "Dec 25"
    return new Intl.DateTimeFormat(this.locale.primaryLocale, {
      month: 'short',
      day: 'numeric'
    });
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TrialInfo);
});